module.exports = __webpack_public_path__ + "static/img/event1.5b0ec88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/event1.png
// module id = FOHd
// module chunks = 0